import { useState } from 'react';
import Cookies from 'universal-cookie';

export const useCookie = (
  key: string,
  initialValue: string,
  initialOptions: any
) => {
  const cookies = new Cookies();

  const [cookie, setCookieState] = useState(() => {
    const existingCookie = cookies.get(key);
    if (existingCookie !== undefined) {
      return existingCookie;
    } else {
      cookies.set(key, initialValue, initialOptions);
      return initialValue;
    }
  });

  const updateCookie = (newValue: string, newOptions: any) => {
    setCookieState(newValue);
    // cookies.set(key, newValue, newOptions);
  };

  const removeItem = () => {
    cookies.remove(key, { path: '/' });
    setCookieState('');
  };

  const getCookie = () => {
    return cookies.get(key);
  };

  return [cookie, updateCookie, removeItem, getCookie] as const;
};
